// extracted by mini-css-extract-plugin
export var quillEditor = "_jk-1";
export var variable = "_jk-0";